/**
 * 配置编译环境和线上环境之间的切换
 * production
 */
console.log(process.env,'...process.envprocess.envprocess.env')
  let mina = process.env.mina;
  let dev = process.env.dev;
  let cApi = process.env.cApi;
  let apiDomain
  let list = [{
    channelId: '',
    dev: 'https://sycsp.yuanquanyun.com.cn',
    prod: 'https://sycsp-prd.matesec.net'
  }, {
    channelId: '',
    dev: 'https://sycsp.yuanquanyun.com.cn',
    prod: 'https://sycsp-prd.matesec.net'
  }, {
    channelId: '',
    dev: 'https://sycsp.yuanquanyun.com.cn',
    prod: 'https://sycsp-prd.matesec.net'
  }]
  
  for (let i = 0; i < list.length; i++) {
    apiDomain = list[i][process.env.NODE_ENV]
  }
  export {
    mina,
    tenantId,
    dev,
    prod,
    cApi,
    apiDomain
  };


// WEBPACK FOOTER //
// ./src/config/env.js